export default "__VITE_ASSET__de7lUHte__"